
import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { useDispatch } from "react-redux"
import { updatePaketlemeData, updateYukData } from "../../../../../features/updateLoad/updateLoadSlice"
import { useState } from "react"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .box{
        width: 18px;
        height: 18px;
        border-radius: 3px;
        border: 2px solid ${({theme}) => theme.mainTextColor};
        display: flex;
        justify-content: center;
        align-items: center;

        .check-icon{
            font-size: 1rem;
            fill: ${({theme}) => theme.mainTextColor};
        }
    }

    .label{
        font-size: var(--font-size-sm);
        font-size: 12px;
        font-weight: var(--font-weight-xl);
    }
`

const YukAdrCheckbox = ({data, isRequired, name, labelText="Yük ADR (Tehlikeli Madde İçeriyor)"}) => {

    const dispatch = useDispatch()

  return (
    <Container>
        <div className="box" onClick={() => dispatch(updateYukData({yukADR: !data.yukADR}))}>{data.yukADR && <GoCheck className="check-icon"/>}</div>
        <div className="label">{labelText}</div>
    </Container>
  )
}

export default YukAdrCheckbox